module.exports = __webpack_public_path__ + "static/walk-in-the-city-741514ccc3307a3340e5a0ccd123c2ff.jpg";